import { render, staticRenderFns } from "./report-story.vue?vue&type=template&id=5c299d30&"
import script from "./report-story.vue?vue&type=script&lang=js&"
export * from "./report-story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports